/**
 * Moderation Cases Open Panel
 *
 * Displays the number of open moderation cases
 */

import { Card, Shimmer, Text } from '@soteria/design-system-ve';

import * as styles from './ModerationStatsPanel.css';

interface ModerationCasesOpenPanelProps {
  casesOpen: number;
  isLoading?: boolean;
}

export function ModerationCasesOpenPanel({ casesOpen, isLoading = false }: ModerationCasesOpenPanelProps) {
  if (isLoading) {
    return (
      <Card elevation="low" padding="medium">
        <div className={styles.panelContent}>
          <div className={styles.header}>
            <span className={styles.title}>CASES OPEN</span>
          </div>
          <Shimmer className={styles.shimmerValue} label="Loading cases open count" />
        </div>
      </Card>
    );
  }

  return (
    <Card elevation="low" padding="medium">
      <div className={styles.panelContent}>
        <div className={styles.header}>
          <span className={styles.title}>CASES OPEN</span>
        </div>
        <Text as="div" className={styles.value}>
          {casesOpen.toLocaleString()}
        </Text>
        <Text as="div" className={styles.subtitle}>
          Pending review
        </Text>
      </div>
    </Card>
  );
}
